import dayjs from "dayjs"
import { useCheckIsHoliday } from "hooks/useRequest/holiday"
import { useEffect, useState } from "react"
import jalaliday from "jalaliday";

dayjs.extend(jalaliday);



const useCallignTime = (): JSX.Element => {

    const [today] = useState(dayjs().calendar("jalali"))

    const [consulationText, setConsulationText] = useState<JSX.Element>(null)


    const { data: holidayData, isSuccess: holidayIsSuccess } = useCheckIsHoliday({
        params: {
            date: today.format("YYYY/MM/DD")
        },
        options: {
            enabled: Boolean(today)
        }
    })

    useEffect(() => {
        if (holidayIsSuccess) {
            let title = null

            if (holidayData.data?.isHoliday) {
                // is holiday
                title = <p>تا 12 ظهر اولین روز کاری</p>
            } else {
                const At15 = dayjs().calendar("jalali").hour(15).minute(0)

                if (At15.diff(today) > 0) {
                    // before today 15:00 time
                    title = <p><b>امروز،</b> تا عصر</p>
                } else {
                    // after today 15:00 time
                    title = <p><b>فردا،</b> تا قبلِ 12 ظهر</p>
                }

                return setConsulationText(title)
            }
        }
    }, [holidayIsSuccess])

    return consulationText
}

export default useCallignTime